import { Injectable } from "@angular/core";
import { IID_OL_OLOREQUEST_OF } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolOloRequestOFStore } from "./iidOlOloRequestOF.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_REQUEST_OF)
export class IIDolOloRequestOFQuery extends AbstractInterfaceDataQuery<IID_OL_OLOREQUEST_OF> {
  constructor(protected store: IIDolOloRequestOFStore) {
    super(store);
  }
}
